<!-- <div #search_container class="search_container"> -->
<!-- TODO: Replace with search component -->
<!-- Search Component -->
<!-- </div> -->
<div *ngIf="!isLoaded" class="load-spinner">
  <div class="fa fa-circle-o-notch fa-spin"></div>
</div>
<div
  #device_info_container
  id="device-info-container"
  class="device-info-container"
  (scroll)="scrollHandler()"
  [ngClass]="{ 'hide-container': !isLoaded }"
  tabindex="0"
>
  <div class="device-detail-nav-container">
    <div>
      <span
        class="hd-icon icon-xsmd hd-icon-device1 integration-icon"
        (click)="scrollToView(device_details)"
        [ngClass]="{ active: highlightIcon(device_details.id) }"
        [soti-tooltip]="'deviceInfo_DeviceDetails_Caption' | xsI18n"
        placement="right"
      >
      </span>
    </div>
    <div>
      <span
        class="hd-icon icon-xsmd hd-icon-cog integration-icon"
        (click)="scrollToView(device_configurations)"
        [ngClass]="{ active: highlightIcon(device_configurations.id) }"
        [soti-tooltip]="'Snapshot_Configurations_Caption' | xsI18n"
        placement="right"
      >
      </span>
    </div>
    <div *ngIf="isSectionSupported(snapshotInstalledApplications)">
      <span
        class="hd-icon icon-xsmd hd-icon-application integration-icon"
        (click)="scrollToView(device_application)"
        [ngClass]="{ active: highlightIcon(device_application.id) }"
        [soti-tooltip]="'home_Applications_menu_category' | xsI18n"
        placement="right"
      >
      </span>
    </div>
    <div>
      <span
        class="hd-icon icon-xsmd hd-icon-security integration-icon"
        (click)="scrollToView(device_security)"
        [ngClass]="{ active: highlightIcon(device_security.id) }"
        [soti-tooltip]="'admin_Settings_SecurityTab' | xsI18n"
        placement="right">
      </span>
    </div>
    <div *ngIf="isSectionSupported(snapshotContent)">
      <span
        class="hd-icon icon-xsmd hd-icon-packages integration-icon"
        (click)="scrollToView(device_content)"
        [ngClass]="{ active: highlightIcon(device_content.id) }"
        [soti-tooltip]="'Snapshot_Content_Caption' | xsI18n"
        placement="right">
      </span>
    </div>
    <div>
      <span
        class="hd-icon icon-xsmd hd-icon-filetype-document integration-icon"
        (click)="scrollToView(device_notes)"
        [ngClass]="{ active: highlightIcon(device_notes.id) }"
        [soti-tooltip]="'Snapshot_Notes_Caption' | xsI18n"
        placement="right"
      >
      </span>
    </div>
  </div>
  <div id="device-info" class="device-info">
    <div class="device-component-router-outlet-container">
      <div #device_info_details_container class="device-info-details" (window:resize)="onResize()">
        <div #device_details id="device_details" class="header">
          <h3>{{ 'deviceInfo_DeviceDetails_Caption' | xsI18n }}</h3>
          <div class="device-infographics">
            <xs-device-infographics
              [title]="'Snapshot_Battery_Caption' | xsI18n"
              [foreColor]="getForeColor('device')"
              [backColor]="getBackColor('device')"
              [available]="snapshotDeviceDetails?.HardwareDetails?.properties?.BatteryStatus?.value | pwr | xsI18n: snapshotDeviceDetails?.HardwareDetails?.properties?.BatteryStatus?.value || ''"
              [isPercentage]="true"
              [isFormatted]="true"
              [icon]="'hd-icon-battery'"
              [smallInfographics]="smallInfographics"
            >
            </xs-device-infographics>
            <xs-device-infographics
              [title]="'Snapshot_Memory_Caption' | xsI18n"
              [foreColor]="getForeColor('memory')"
              [backColor]="getBackColor('memory')"
              [available]="snapshotDeviceDetails?.HardwareDetails?.properties?.AvailableMemory?.value"
              [total]="snapshotDeviceDetails?.HardwareDetails?.properties?.TotalMemory?.value"
              [isPercentage]="false"
              [icon]="'hd-icon-memory'"
              [smallInfographics]="smallInfographics"
            >
            </xs-device-infographics>
            <xs-device-infographics
              [title]="'Snapshot_Storage_Caption' | xsI18n"
              [foreColor]="getForeColor('storage')"
              [backColor]="getBackColor('storage')"
              [available]="snapshotDeviceDetails?.HardwareDetails?.properties?.AvailableStorage?.value"
              [total]="snapshotDeviceDetails?.HardwareDetails?.properties?.TotalStorage?.value"
              [isPercentage]="false"
              [icon]="'hd-icon-storage'"
              [smallInfographics]="smallInfographics"
            >
            </xs-device-infographics>
          </div>
          <div class="component-wrapper">
            <ng-container *ngIf="deviceDetailBasicProperties">
              <app-key-value-table
                [tableJsonData]="deviceDetailBasicProperties['properties']"
                [tableTitle]="deviceDetailBasicProperties['resourceCaption']"
              ></app-key-value-table>
            </ng-container>
          </div>
          <ng-container *ngIf="snapshotDeviceDetails">
            <ng-container *ngFor="let item of snapshotDeviceDetails | keyvalue">
              <div
                *ngIf="isCustomAttributes(item) && hasRowData(item)"
                class="component-wrapper"
                [hidden]="!isSectionSupported(item.value)"
              >
                <app-dynamic-table
                  [title]="item.value['resourceCaption']"
                  [tableRawData]="item.value"
                ></app-dynamic-table>
              </div>
              <div
                *ngIf="!isCustomAttributes(item)"
                class="component-wrapper"
                [hidden]="!isSectionSupported(item.value)"
              >
                <app-key-value-table
                  [tableJsonData]="item.value['properties']"
                  [tableTitle]="item.value['resourceCaption']"
                ></app-key-value-table>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <div #device_configurations id="device_configurations" class="header">
          <h3>{{ 'Snapshot_Configurations_Caption' | xsI18n }}</h3>
          <ng-container>
            <ng-container *ngFor="let item of snapshotConfigurations | keyvalue">
              <div class="component-wrapper">
                <span [hidden]="!isSectionSupported(item.value)">
                  <app-dynamic-table
                    [title]="item.value.resourceCaption"
                    [tableRawData]="item.value"
                    *ngIf="item['key'] !== 'Profiles' || !snapshotProfiles"
                  >
                  </app-dynamic-table>
                </span>
                <span [hidden]="!isSectionSupported(item.value)">
                  <app-dynamic-table
                    [title]="snapshotProfiles.resourceCaption"
                    [tableRawData]="snapshotProfiles"
                    [hasCollapsibleRowGroups]="true"
                    [rowGroupHeaderColumn]="snapshotProfiles?.properties?.Name['key']"
                    [isARowGroupHeaderRow]="isProfileRowGroupHeader"
                    [fieldToFilterOn]="'ProfileName'"
                    *ngIf="item['key'] === 'Profiles' && snapshotProfiles"
                  >
                  </app-dynamic-table>
                </span>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <div
          #device_application
          id="device_application"
          class="header"
          [hidden]="!isSectionSupported(snapshotInstalledApplications)"
        >
          <h3>{{ 'home_Applications_menu_category' | xsI18n }}</h3>
          <ng-container *ngIf="snapshotInstalledApplications">
            <div class="component-wrapper" [hidden]="!isSectionSupported(snapshotInstalledApplications)">
              <app-dynamic-table
                [title]="snapshotInstalledApplications.resourceCaption"
                [tableRawData]="snapshotInstalledApplications"
              ></app-dynamic-table>
            </div>
          </ng-container>
          <ng-container *ngIf="snapshotProvisioningProfiles">
            <div class="component-wrapper" [hidden]="!isSectionSupported(snapshotProvisioningProfiles)">
              <app-dynamic-table
                [title]="snapshotProvisioningProfiles.resourceCaption"
                [tableRawData]="snapshotProvisioningProfiles"
              ></app-dynamic-table>
            </div>
          </ng-container>
        </div>

        <div #device_security id="device_security" class="header">
          <h3>{{ 'admin_Settings_SecurityTab' | xsI18n }}</h3>
          <ng-container *ngIf="snapshotSecurity">
            <div class="component-wrapper" [hidden]="!isSectionSupported(snapshotSecurity.Certificates)">
              <app-dynamic-table
                [title]="snapshotSecurity.Certificates.resourceCaption"
                [minimumColumnWidth]="200"
                [tableRawData]="snapshotSecurity.Certificates"
              ></app-dynamic-table>
            </div>
            <div class="component-wrapper" [hidden]="!isSectionSupported(snapshotSecurity.Quarantine)">
              <app-dynamic-table
                [title]="snapshotSecurity.Quarantine.resourceCaption"
                [tableRawData]="snapshotSecurity.Quarantine"
              ></app-dynamic-table>
            </div>
          </ng-container>
        </div>

        <div #device_content id="device_content" class="header" [hidden]="!isSectionSupported(snapshotContent)">
          <h3>{{ 'Snapshot_Content_Caption' | xsI18n }}</h3>
          <ng-container *ngIf="snapshotContent">
            <div class="component-wrapper" [hidden]="!snapshotContent.isSupported">
              <app-dynamic-table
                [title]="snapshotContent.resourceCaption"
                [tableRawData]="snapshotContent"
              ></app-dynamic-table>
            </div>
          </ng-container>
        </div>

        <div #device_notes id="device_notes" class="header">
          <h3>{{ 'Snapshot_Notes_Caption' | xsI18n }}</h3>
          <ng-container *ngIf="snapshotNotes">
            <div class="component-wrapper notes" [hidden]="!snapshotNotes.isSupported">
              <app-card [title]="snapshotNotes.resourceCaption" [datasource]="snapshotNotes"></app-card>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
